<form [formGroup]="direccionForm" (ngSubmit)="actualizarDireccion()" class="servicio">
  <div class="intro">
    <div class="userData">
      <div class="welcome">
        <div class="info">
          <div class="titulo-servicios">
            <svg width="24" height="24" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 9.24805C5 8.83383 5.33579 8.49805 5.75 8.49805H8.25V6.24713C8.25 5.83292 8.58579 5.49713 9 5.49713C9.41421 5.49713 9.75 5.83292 9.75 6.24713V8.49805H12.25C12.6642 8.49805 13 8.83383 13 9.24805C13 9.66226 12.6642 9.99805 12.25 9.99805H9.75V12.2471C9.75 12.6613 9.41421 12.9971 9 12.9971C8.58579 12.9971 8.25 12.6613 8.25 12.2471V9.99805H5.75C5.33579 9.99805 5 9.66226 5 9.24805ZM2.84328 3.06593C6.24369 -0.334478 11.7568 -0.334478 15.1573 3.06593C18.5577 6.46634 18.5577 11.9795 15.1573 15.3799L13.9703 16.5538C13.0954 17.4125 11.9603 18.5164 10.5644 19.866C9.69218 20.7093 8.30836 20.7092 7.43624 19.8657L3.94515 16.4699C3.50638 16.039 3.13912 15.6757 2.84328 15.3799C-0.557134 11.9795 -0.557134 6.46634 2.84328 3.06593ZM14.0966 4.12659C11.282 1.31197 6.71856 1.31197 3.90394 4.12659C1.08931 6.94122 1.08931 11.5046 3.90394 14.3192L5.39101 15.7867C6.20992 16.5882 7.23938 17.5886 8.47906 18.7875C8.76976 19.0687 9.23104 19.0687 9.52178 18.7876L12.9167 15.4861C13.3856 15.0259 13.779 14.6369 14.0966 14.3192C16.9112 11.5046 16.9112 6.94122 14.0966 4.12659Z" fill="#208FE4"/>
            </svg>
            <h1>Actualiza dirección</h1>
          </div>
        </div>

        
        <div class="map-wrapper">
          <app-map  *ngIf="latitud !== null && longitud !== null"  [mode]="'update'"  [updateCoordinates]="{ lat: latitud!, lng: longitud! }" height="100%" width="100%" (getAddress)="getPlaces($event)" (getCordinate)="getReverseByCordinates($event)" (getByAdreessByCordinate)="getReverseByAdreess($event)"></app-map>
        </div>
       
        <p class="text-[var(--login-p,#3D4E5F)] text-center w-full flex justify-center">Si la dirección no es correcta, ingrésala manualmente.</p>

        <!-- Campos del formulario -->
        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Identificador</mat-label>
          <input matInput type="text" formControlName="identificador">
          <mat-error *ngIf="direccionForm.get('identificador')?.hasError('required')">
            Campo obligatorio
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Calle y número</mat-label>
          <input matInput type="text" formControlName="calleNumero">
          <mat-error *ngIf="direccionForm.get('calleNumero')?.hasError('required')">
            Campo obligatorio
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Interior</mat-label>
          <input matInput type="text" formControlName="interior">
        </mat-form-field>

        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Código Postal</mat-label>
          <input matInput type="text" formControlName="codigoPostal" (keypress)="soloNumeros($event)">
          <mat-error *ngIf="direccionForm.get('codigoPostal')?.hasError('required')">
            Campo obligatorio
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Colonia</mat-label>
          <input matInput type="text" formControlName="colonia" (keypress)="soloLetras($event)">
          <mat-error *ngIf="direccionForm.get('colonia')?.hasError('required')">
            Campo obligatorio
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Ciudad</mat-label>
          <mat-select formControlName="ciudad" (selectionChange)="onCiudadChange($event)">
            <mat-option *ngFor="let ciudad of catalogoCiudades" [value]="ciudad.id">
              {{ ciudad.descripcion }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="direccionForm.get('ciudad')?.hasError('required')">
            Campo obligatorio
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Municipio</mat-label>
          <mat-select formControlName="municipio" (selectionChange)="onMunicipioChange($event)">
            <mat-option *ngFor="let municipio of catalogoMunicipios" [value]="municipio.id">
              {{ municipio.descripcion }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="direccionForm.get('municipio')?.hasError('required')">
            Campo obligatorio
          </mat-error>
        </mat-form-field>
        
        <p class="text-[var(--login-p,#3D4E5F)] text-center m-3 w-full flex justify-center">Los campos con * son obligatorios.</p>
        <!-- Botón actualizar -->
        <div class="button-row">
          <button type="submit" class="register-button" >
            <span>Actualizar dirección</span>
            <svg width="12" height="12" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 3C6.27614 3 6.5 3.22386 6.5 3.5V4.99933H8C8.27614 4.99933 8.5 5.22319 8.5 5.49933C8.5 5.77547 8.27614 5.99933 8 5.99933H6.5V7.5C6.5 7.77614 6.27614 8 6 8C5.72386 8 5.5 7.77614 5.5 7.5V5.99933H4C3.72386 5.99933 3.5 5.77547 3.5 5.49933C3.5 5.22319 3.72386 4.99933 4 4.99933H5.5V3.5C5.5 3.22386 5.72386 3 6 3ZM12 6C12 8.8739 8.90276 12.0162 7.15886 13.5577C6.4905 14.1485 5.5095 14.1485 4.84114 13.5577C3.09724 12.0162 0 8.8739 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 7.10846 1.61464 8.39535 2.56972 9.68269C3.50366 10.9415 4.65694 12.0602 5.50343 12.8085C5.79356 13.065 6.20644 13.065 6.49657 12.8085C7.34306 12.0602 8.49634 10.9415 9.43028 9.68269C10.3854 8.39535 11 7.10846 11 6Z" fill="#D9E7F3"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</form>